import { render, staticRenderFns } from "./ComboParceiros.vue?vue&type=template&id=3536bf78&scoped=true"
import script from "./ComboParceiros.vue?vue&type=script&lang=js"
export * from "./ComboParceiros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3536bf78",
  null
  
)

export default component.exports